export const QueryDefaults = {
  // 1 minute before data is refreshed, unless invalidated to say it's changed
  staleTime: 60000,
};

export const PermissionsQueryDefaults = {
  // 15 minutes
  staleTime: 900000,
};
